import * as React from 'react'
import { useTheme } from '@/presentation/hooks'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-foreground group-[.toaster]:text-text-title group-[.toaster]:border-background group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-text-subtitle',
          actionButton:
            'group-[.toast]:bg-greenGarupa group-[.toast]:text-white',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-text-muted',
          success:
            'group-[.toaster]:bg-foreground group-[.toaster]:text-text-title',
          error:
            'group-[.toaster]:bg-foreground group-[.toaster]:text-text-title',
          warning:
            'group-[.toaster]:bg-foreground group-[.toaster]:text-text-title',
          info: 'group-[.toaster]:bg-foreground group-[.toaster]:text-text-title',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
